export var MessagesTypes;
(function (MessagesTypes) {
    MessagesTypes["NOT_FOUND"] = "NOT_FOUND";
    MessagesTypes["EMPTY"] = "EMPTY";
})(MessagesTypes || (MessagesTypes = {}));
export const defaultMessages = {
    NOT_FOUND: 'Nothing found',
    EMPTY: 'List is empty',
};
